import * as react from "react";

export const title = "Ancestors map";

export const footer = react.createElement("div", {});

